import { StyledTitle } from "./Header.styles";

export const Header = () => (
  <header>
    <StyledTitle>Todo List</StyledTitle>
  </header>
);
